import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer, Navbar } from "..";
import Sidebar from "../Sidebar";
import PopupHandlerLayout from "./PopupHandlerLayout";
import { AppDispatch, RootState } from "../../store";
import { useDispatch } from "react-redux";
import { fetchStaffAccess } from "../../features/access-controller/AccessController";
import { useSelector } from "react-redux";
import { PermissionsProvider } from "../../context/PermissionProvider";
import { getLocalStorage } from "../../util/manageStorage";
import { getDaysLeft } from "../../util/functions/UniversalFunctions";
import SubscriptionExpiredModal from "../modal/SubscriptionExpiredModal";

export default function EmpedanceMainLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const staffId = useSelector((state: RootState) => state.user?.user?.userId);

  const noPaddingRoutes = ["/", "/dashboard"];
  const hasPadding = !noPaddingRoutes.includes(location.pathname);

  const subscription = useSelector(
    (state: RootState) => state.access.subscription,
  );

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!staffId) return;

    const storedBranchCode = getLocalStorage("selectedBranchCode");

    dispatch(
      fetchStaffAccess({
        userId: Number(staffId),
        branchCode: storedBranchCode || undefined,
      }),
    );
  }, [staffId, dispatch]);

  useEffect(() => {
    if (!subscription) return;

    const isExpired =
      subscription?.status !== "ACTIVE" ||
      (subscription?.endDate && getDaysLeft(subscription.endDate) < 0);

    if (isExpired) {
      setShowPopup(true);
    }
  }, [subscription]);

  return (
    <main className="flex min-h-screen">
      {/* Main content */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <PopupHandlerLayout />
      <div className="flex flex-col flex-1 max-h-screen overflow-y-auto">
        {/* Navbar */}
        <Navbar onMenuClick={() => setIsSidebarOpen(true)} />

        {/* Page content + Footer */}
        <div className="flex flex-col flex-1 bg-background-100">
          <div
            className={`flex-1 ${
              hasPadding ? "px-5  py-3 xl:px-8" : "pl-5 py-[10px]"
            }`}
          >
            <PermissionsProvider>
              <Outlet />
            </PermissionsProvider>
          </div>
          <Footer />
        </div>
      </div>

      {showPopup && <SubscriptionExpiredModal isOpen={showPopup} />}
    </main>
  );
}
